const HomeContentData = {
  title: "REGISTERED",
  title2: "NDIS PROVIDER",
  description: `DNCC is a registered healthcare provider that is committed to empowering individuals with disabilities to enhance their quality of life under the National Disability Insurance Scheme (NDIS). We provide a wide range of capacity and skill-building programs, as well as personalized support services, that are tailored to meet the unique needs of each of our clients. Our offerings are designed to address the distinctive requirements of individuals with disabilities, ensuring that they receive the necessary support and assistance to live fulfilling lives.`,
  buttonText: "My Button",
};

export default HomeContentData;
